export const employee_level_permission= {
    required_permission:['view_employeelevel', 'add_employeelevel', 'change_employeelevel', 'delete_employeelevel' ]
}